import React from "react";
import { motion } from "framer-motion";
import { CalendarClockIcon, FolderOpenIcon, ClipboardListIcon, RepeatIcon, MessageSquareIcon, FileTextIcon, BuildingIcon, BarChart3Icon, BoxIcon } from "lucide-react";
import { SectionTag } from "./SectionTag";
import { PROBLEM_CLOSER, PROBLEM_TASKS } from "./salesData";
const TASK_ICONS: Record<string, BoxIcon> = {
  preparar: CalendarClockIcon,
  informacion: FolderOpenIcon,
  planes: ClipboardListIcon,
  seguimiento: RepeatIcon,
  pacientes: MessageSquareIcon,
  materiales: FileTextIcon,
  gestion: BuildingIcon,
  datos: BarChart3Icon
};
export function ProblemSection() {
  return <section id="problema" className="bg-bone py-14 sm:py-24" aria-labelledby="problem-title" data-id="element-212" data-mp="3jequarvzvbgg">
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-8" data-id="element-213" data-mp="3eia8438cv760">
        <div className="max-w-3xl" data-id="element-214" data-mp="1p1ssyxs9vp59">
          <SectionTag data-id="element-215" data-mp="1p2u2gxtn43kv">El problema</SectionTag>
          <h2 id="problem-title" className="mt-4 font-display text-[1.5rem] uppercase leading-[1.08] text-charcoal sm:text-[2.4rem]" data-id="element-216" data-mp="1k2xy2xh16a4s">
            Tu problema no es la falta de conocimiento.
            <span className="mt-2 block text-gold-deep" data-id="element-217" data-mp="jbafd49o9jhb">
              Es todo lo que tenés que hacer alrededor de una consulta.
            </span>
          </h2>
        </div>

        <ul className="mt-8 grid grid-cols-2 gap-2.5 sm:mt-12 sm:grid-cols-4 sm:gap-4" data-id="element-218" data-mp="scibbfopu888">
          {PROBLEM_TASKS.map((task, index) => {
          const Icon = TASK_ICONS[task.id];
          return <motion.li key={task.id} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.4
          }} transition={{
            duration: 0.28,
            ease: [0.23, 1, 0.32, 1],
            delay: Math.min(index, 4) * 0.035
          }} className="flex items-center gap-3 rounded-2xl border border-warm bg-ivory p-3 shadow-[0_10px_24px_-22px_rgba(34,34,34,0.5)] transition-transform duration-200 ease-out hover:-translate-y-0.5 sm:flex-col sm:items-start sm:p-5" data-id="element-219" data-mp="123376vd08yng" data-mpi={index}>
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gold-pale sm:h-10 sm:w-10" aria-hidden data-id="element-220" data-mp="p0is1hvnbllt">
                  <Icon className="h-4 w-4 text-gold-deep sm:h-[1.15rem] sm:w-[1.15rem]" data-id="element-221" data-mp="y0oywkwu9nc0" />
                </span>
                <span className="font-sans text-[0.78rem] font-semibold leading-tight text-charcoal sm:text-[0.92rem] sm:leading-snug" data-id="element-222" data-mp="tz3t1jiq29bb">
                  {task.label}
                </span>
              </motion.li>;
        })}
        </ul>

        <div className="mt-9 border-l-2 border-gold pl-5 sm:mt-14 sm:pl-7" data-id="element-223" data-mp="12zrw5j6kup9f">
          <p className="font-display text-[1.15rem] uppercase leading-[1.15] text-charcoal sm:text-[1.75rem]" data-id="element-224" data-mp="1hnwkb2oefszl">
            {PROBLEM_CLOSER}
          </p>
        </div>
      </div>
    </section>;
}